import {  useSelector, useDispatch } from 'react-redux';
import FloatingLabelInput from "../../components/floatingLabelInput";
import { useEffect } from 'react';
import FloatingLabelTextArea from '../../components/floatingLabelTextArea';
import { fetchInitialState, setFieldError, SubmitLocalITCompanyDetails, updateLocalITCompanyDetails, updateLocalITCompanyOption } from './localITCompanySlice';
import Loader from '../../components/loader';
import { OptionCard, OptionCardRow, OptionCardSeparator, StepHeading, StepShell } from '../../components/optionCard';
import { formatPhoneNumber, validateField } from '../utils';
import { BACKEND_API_URL } from '../../config';
import { showRejectedError } from "../../admin/components/onboarding/apiHelper";
  
const LocalITCompanyDetails = () => {
    const dispatch = useDispatch();
    const localITCompanyDetailsState = useSelector(state => state.local_it_company);

    useEffect(() => {
        dispatch(fetchInitialState())
    },[dispatch])

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        const validation = validateField(name, value);
        if (name === 'contactPhone') {
            const formattedPhoneNumber = formatPhoneNumber(value);
            dispatch(updateLocalITCompanyDetails({ field: name, value: formattedPhoneNumber }));
            dispatch(setFieldError({ field: name, error: ''}));
        }
        else if (name === 'email') {
            dispatch(updateLocalITCompanyDetails({ field: name, value: value }));
            dispatch(setFieldError({ field: name, error: ''}));
        }
        else {
            dispatch(updateLocalITCompanyDetails({ field: name, value }));
            if (!validation) dispatch(setFieldError({ field: name, error: `Please enter a valid ${name}`}))
            else dispatch(setFieldError({ field: name, error: ''}))
        }
    }

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === 'contactPhone') {
            // Check if the number has 10 digits
            const rawNumbers = value.replace(/[^\d]/g, '');
            if (rawNumbers.length !== 10) {
                dispatch(setFieldError({ field: name, error: "Please enter a valid phone number" }));
            }
        }
        else if (name === 'email') {
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                dispatch(setFieldError({ field: name, error: "Please enter a valid email address" }));
            }
        }
        else {
            if (value === '') {
                dispatch(setFieldError({ field: name, error: `Please enter a valid ${name}`}))
            }
        }
        
      };

    const handleDownload = (e) => {
        e.preventDefault()
        const url = `${BACKEND_API_URL}/api/files/download?path=${encodeURIComponent(localITCompanyDetailsState.data.agreementFile)}`;
          fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // Specify a filename for the downloaded file
                a.download = localITCompanyDetailsState.data.agreementFile.split("/").pop();
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(err => console.error('Fetch error:', err));
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            // Handle file selection via input
            let uploadedFile = e.target.files[0];
            dispatch(SubmitLocalITCompanyDetails({ ...localITCompanyDetailsState.data, 'agreementFile': uploadedFile }))
            .unwrap().then(() => console.log("Called")).catch(showRejectedError())

        } else if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Handle file drop
            let uploadedFile = e.dataTransfer.files[0];
            dispatch(SubmitLocalITCompanyDetails({ ...localITCompanyDetailsState.data, 'agreementFile': uploadedFile }))
            .unwrap().then(() => console.log("Called")).catch(showRejectedError())
        }
        e.target.value = null;
    }

    const handleDelete = (e) => {
        e.preventDefault()
        dispatch(SubmitLocalITCompanyDetails({ ...localITCompanyDetailsState.data, 'agreementFile': 'delete' }))
        .unwrap().catch(showRejectedError())
      };

    return (
        <>
            { localITCompanyDetailsState.loading && <Loader /> }
            <StepShell className="mb-14">
                <StepHeading>
                    Do you work with a local IT Company?
                </StepHeading>

            <OptionCardRow>
                {/* Yes Option */}
                <OptionCard
                    selected={localITCompanyDetailsState.data._option === 'Yes'}
                    onClick={() => dispatch(updateLocalITCompanyOption('Yes'))}
                >
                    Yes
                </OptionCard>

                <OptionCardSeparator />

                {/* No Option */}
                <OptionCard
                    selected={localITCompanyDetailsState.data._option === 'No'}
                    onClick={() => dispatch(updateLocalITCompanyOption('No'))}
                >
                    No
                </OptionCard>
            </OptionCardRow>
            </StepShell>
            { localITCompanyDetailsState.data._option === 'Yes' && (
                <div className="mx-auto w-full max-w-2xl">
                    <div className="flex flex-col items-center justify-center mt-14 mb-10">
                        <h3 className="text-center text-xl font-bold text-[#0a1445] sm:text-2xl">
                            Please provide their details.
                        </h3>
                    </div>
                    <form>
                        <div className="pb-12 space-y-12">
                            <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            value={localITCompanyDetailsState.data.company}
                                            error={localITCompanyDetailsState.formErrors.company}
                                            name="company" 
                                            id="company" 
                                            label="Company Name" 
                                            required={true}
                                        />
                                </div>
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            value={localITCompanyDetailsState.data.contactName} 
                                            error={localITCompanyDetailsState.formErrors.contactName}
                                            name="contactName" 
                                            id="contactName" 
                                            type="text" 
                                            label="Contact Name" 
                                            required={true}
                                        />
                                </div>
                            </div>
                            <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            value={localITCompanyDetailsState.data.email} 
                                            error={localITCompanyDetailsState.formErrors.email}
                                            name="email" 
                                            id="email" 
                                            type="email" 
                                            label="Email" 
                                            required={true}
                                        />
                                </div>
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            value={localITCompanyDetailsState.data.contactPhone} 
                                            error={localITCompanyDetailsState.formErrors.contactPhone}
                                            name="contactPhone" 
                                            id="contactPhone" 
                                            type="tel" 
                                            label="Contact Phone Number" 
                                            required={true}
                                        />
                                </div>
                            </div>
                            <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-6">
                                    <FloatingLabelTextArea 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            value={localITCompanyDetailsState.data.servicesProvided}
                                            error={localITCompanyDetailsState.formErrors.servicesProvided} 
                                            name="servicesProvided" 
                                            id="servicesProvided" 
                                            type="text" 
                                            label="IT Services Provided" 
                                            required={true}
                                        />
                                </div>
                            </div>

                            {/* Optional Upload Docs */}
                            <div className="flex items-center justify-center">                            
                                {(localITCompanyDetailsState.data.agreementFile && localITCompanyDetailsState.data.agreementFile !== 'null') ? (
                                    <div className="grid grid-cols-5 justify-between items-center gap-2 p-4 bg-gray-50 shadow-md rounded-lg mb-2">
                                            <p className="col-span-4 text-sm font-medium text-indigo-600 truncate">
                                                {localITCompanyDetailsState.data.agreementFile.split("/").pop()}
                                            </p>
                                            <div className="col-span-1 flex justify-end">
                                                <button
                                                    onClick={handleDownload}
                                                    className="text-sm  hover:bg-blue-300 text-blue-700 py-2 px-4 rounded"
                                                >
                                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                                                    </svg> */}
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 24 24" width="26">
                                                        <path d="M0 0h24v24H0z" fill="none"/>
                                                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                                    </svg>
                                                </button>
                                                <button
                                                    onClick={handleDelete}
                                                    className="text-sm hover:bg-red-300 text-red-700 py-2 px-4 rounded"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                    </svg>
                                                </button>
                                        </div>
                                    </div>
                                ) : 
                                    <div className="flex items-center justify-center w-80"
                                            onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
                                            onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
                                            onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
                                            onDrop={(e) => { e.preventDefault(); e.stopPropagation(); handleFileChange(e)}}
                                        >
                                        <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full  border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ">
                                            <div className="flex flex-col items-center justify-center pt-5 pb-4">
                                                <svg className="w-8 h-8 mb-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                                </svg>
                                                <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">Click to upload an Agreement/Contract</span> </p>
                                                <p className="mb-2 text-sm text-gray-500 ">or drag and drop</p>
                                                <p className="mt-2 text-sm text-gray-500 "><span className="font-semibold">(Optional)</span> </p>
                                                {/* <p className="text-xs text-gray-500 ">PDF Only</p> */}
                                            </div>
                                            <input name='agreementFile'
                                                id="dropzone-file" 
                                                type="file" 
                                                className="hidden" 
                                                onChange={handleFileChange} 
                                            />
                                        </label>
                                    </div> 
                                }
                            </div> 
                        </div>
                    </form>
                </div>
            )}
        </>

    )
}

export default LocalITCompanyDetails;
